/**
 * `Filters` slots are controlled with `value: string[]` (even `multiple: false` emits
 * `[optValue]`, and removing the chip emits `[]`), while `FilterSlideout` single-select sections
 * and the page state use a scalar. These two functions are the ONLY place the two shapes meet:
 * page state keeps one scalar source of truth.
 */

/** Scalar to the array a `Filters` slot expects; empty and the "all" value mean no selection. */
export const toSlotValue = (scalar, allValue = '') =>
  scalar && scalar !== allValue ? [scalar] : [];

/** What a `Filters` slot emitted back to a scalar: the last value, or '' when cleared. */
export const fromSlotValue = (next) => (next?.length ? next[next.length - 1] : '');
